import { useEffect } from "react"

import { Divider, Flex, Typography } from "antd"
import { t } from "i18next"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router"
import { useSearchParams } from "react-router-dom"

import ButtonComponent from "../../Components/Button"
import Icon from "../../Icon"
import { getDates } from "../../Utils/utils"
import AlertsBySourceTable from "./components/AlertsBySourceTable/AlertsBySourceTable"
import ReferralsOverviewChart from "./components/OverviewChart"
import { ReferralFilterBlock } from "./components/OverviewChartFilters"
import OverviewTotalReward from "./components/OverviewTotalReward"
import ReferralBAInfo from "./components/ReferralBAInfo/ReferralBAInfo"
import ReferralActions from "./reducer"

import "./styles.less"

const { Text } = Typography

const ReferralBAPage = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { id } = useParams()
  const [searchParams] = useSearchParams()
  const userId = searchParams.get("user_id")

  const goBack = () => {
    navigate("/referral")
  }

  const { isAdmin } = useSelector((state) => state.auth)
  const { earningsFilters, overviewMainInfo, alertsBySourceTable, referralBusinessAccount } =
    useSelector((state) => state.referrals)

  const params = { user_id: userId }

  const setFilters = (filters) => {
    if (Array.isArray(filters.period)) {
      dispatch(
        ReferralActions.setEarningsFilters({
          __preset_period: filters?.__preset_period,
          period: { type: "custom", period: filters.period }
        })
      )
    } else {
      dispatch(ReferralActions.setEarningsFilters(filters))
    }
  }

  useEffect(() => {
    const period_query = getDates(earningsFilters.period)
    const businessAccountsQuery = { business_account_id: id }
    dispatch(
      ReferralActions.getReferralsOverviewDataRequest({
        ...period_query,
        ...businessAccountsQuery,
        ...params
      })
    )
    dispatch(
      ReferralActions.getReferralsOverviewMainInfoRequest({
        ...period_query,
        ...businessAccountsQuery,
        ...params
      })
    )
    dispatch(
      ReferralActions.getAlertsBySourceTableRequest({
        ...period_query,
        ...businessAccountsQuery,
        ...params
      })
    )
  }, [earningsFilters])

  useEffect(() => {
    if (id) {
      dispatch(ReferralActions.getReferralBusinessAccountInfoRequest(id))
    }
  }, [id])

  useEffect(() => {
    document.title = "Rewards details & activity"
  }, [])

  return (
    <Flex className="referral-ba-page" vertical gap={24}>
      <Flex gap={8} align="center">
        <ButtonComponent
          type="text"
          icon={<Icon type="arrow_left" />}
          style={{ width: 32 }}
          onClick={goBack}
        />
        <Text strong style={{ fontSize: 18, lineHeight: 1.4 }}>
          {t("Rewards details & activity")}
        </Text>
      </Flex>
      <ReferralBAInfo data={referralBusinessAccount} />
      <Divider style={{ marginBottom: 16, marginTop: 40 }} />
      <Flex vertical>
        <Text className="overview-title">Overview</Text>
        <ReferralFilterBlock filters={earningsFilters} handleChangeFilter={setFilters} />
        <OverviewTotalReward
          title="Alerts Overview"
          reward={overviewMainInfo?.total_reward ?? 0}
          count={overviewMainInfo?.total_count ?? 0}
          withoutTooltip
          style={{ marginBottom: 22 }}
        />
        <ReferralsOverviewChart />
        <Text className="alert-by-source-header">Alerts by Source</Text>
        <AlertsBySourceTable data={alertsBySourceTable} />
      </Flex>
    </Flex>
  )
}

export default ReferralBAPage
